import { select } from '@angular-redux/store';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, lastValueFrom, Observable, Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { Utils } from 'sharedFeatures/utils';
import { DialogCreator } from 'sharedFeatures/window';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { SharedGuiSmallModule } from '../../../../sharedGuiSmall/sharedGuiSmall.module';
import { AuthData } from '../../../sharedModels';
import { InfoPopup } from './popup/info-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'infoPopUp',
    templateUrl: 'infoPopUp.component.html',
    styleUrls: ['infoPopUp.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule]
})

export class infoPopUpComponent {

    @Output() infoOpened: EventEmitter<any> = new EventEmitter();
    @Input() logoText: string = '';

    @Input() pFieldID : string = '';
    private titleText: string = '';
    private mainText: string = '';

    @Input() isLeft: boolean = false;
    @Input() forceDownPush: number = 0;
    @Input() top: number = -1;
    @Input() isCustomImage: boolean = false;
    @Input() customImageCss: string = "";

    public isPopedUp: boolean = false;

    topMargin: number = 0;

    prevWidth: number = 0;
    prevHeight: number = 0;


    @Input() textCls: string = 'b1Color h4Font';

    @Input()
    disabled: boolean = false;

    @Input()
    public dCreator: DialogCreator | undefined;

    @Input()
    testId: string = '';

    private popup: InfoPopup | undefined;

    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    @select(['account', 'authData'])
    readonly authData$!: Observable<AuthData>;
    authData: AuthData = new AuthData();

    constructor(private http: HttpClient,
        private element: ElementRef,
        private renderer: Renderer2,
        private chDet: ChangeDetectorRef,
        private router: Router,
        private translate: TranslateService) {
            router.events.subscribe(() => {
                // see also
                this.close();
            });
    }

    ngOnInit() {
        // Subscribe on the redux store
        this.subscribeReduxStore();
    }

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.authData$?.pipe(
            takeUntil(this.storeUnsubscribe))
            ?.subscribe((x: AuthData) => this.authData = x);
    }

    @HostListener('document:click')
    public onClick() {
        this.close();
    }

    close() {
        this.isPopedUp = false;
        if (this.popup) this.popup.close();
    }

    open(event: Event) {
        if (this.isPopedUp) {
            this.close();
            return;
        }

        const response = this.http.post<string>(window.balancerApiUrl + 'DataForms/LoadObjectHelp', { pFieldID: this.pFieldID, userID: this.authData.userID });
        lastValueFrom(response)
            .then((resp: string) => {
                if (resp.indexOf('error=sessiontimeout') > -1)
                    return;

                let respBody = JSON.parse(resp);
                this.titleText = respBody.title;
                this.mainText = respBody.text;

                event.stopPropagation();
                this.infoOpened.emit(this.pFieldID);
                this.isPopedUp = !this.isPopedUp;
                if (this.dCreator)
                    if (this.isPopedUp) {

                        let creator = this.dCreator;
                        let translatedTitle = "", translatedBody = "";
                        this.popup = <InfoPopup>creator.createDialog(InfoPopup);

                        this.translate.get(this.titleText).subscribe(translatedText => {
                            translatedTitle = translatedText;
                        });
                        this.translate.get(this.mainText).subscribe(translatedText => {
                            translatedBody = translatedText;
                        });
                        console.log(this.titleText);
                        console.log(this.mainText);
                        this.popup.setTitleText(translatedTitle);
                        this.popup.setBodyText(translatedBody);

                        this.infoPopupHandle(window, event, 'resize');
                        this.infoPopupHandle(document, event, 'wheel');

                        const target = event.target;
                        const offset = DomSmallUtils.offset(<HTMLElement>target);

                        this.popup.showForPoint(offset.left, offset.top);
                        this.popup.setZIndex(Utils.getZIndex(this.element.nativeElement));
                    }
                    else
                        this.close();
            })
            .catch(error => { console.error(error); })
    }

    infoPopupHandle(targetEl: GlobalEventHandlers, event: Event, eventName: string): void {

        fromEvent(targetEl, eventName)
            .pipe(
                debounceTime(200),
                takeUntil(this.storeUnsubscribe)
            ).subscribe(() => {

            const offset = DomSmallUtils.offset(<HTMLElement>event.target);
            let pointX = offset.left;
            let pointY = offset.top;

            if ((pointX < 0 || pointY < 0) || (pointX > window.innerWidth || pointY > window.innerHeight))
                this.close();
            else if (pointX !== this.prevWidth || pointY !== this.prevHeight)
                this.popup!.showForPoint(pointX, pointY);

            this.prevWidth = pointX;
            this.prevHeight = pointY;
        });
    }
}
